import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, watch } from 'vue'
    import { usePageReloaded, useOrganizationUnitId } from '@common/composables'
    import { useAdminPipelinesDashboardPage } from '@Integrations/Pipelines/pages-core'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'AdminDashboardPage',
  setup(__props) {

    document.title = "Manage pipelines"

    const reloaded = usePageReloaded()
    const tid = useOrganizationUnitId()

    const { useCurrentUserQuery, usePipelinesDashboardQuery, useLastRunsQuery } = useAdminPipelinesDashboardPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { modelPipelinesDashboardQueryV1, runPipelinesDashboardQueryV1 } = usePipelinesDashboardQuery(tid)
    const organiationUnitId = computed(() => modelPipelinesDashboardQueryV1.value?.OrganizationUnitId)
    
    const { modelLastRunsQueryV1, runLastRunsQueryV1 } = useLastRunsQuery(organiationUnitId, reloaded)
    const lastRuns = computed(() => modelLastRunsQueryV1.value?.Runs || [])

    onMounted(() => {
        runCurrentUserQueryV1()
        runPipelinesDashboardQueryV1()
    })

    watch(organiationUnitId, () => runLastRunsQueryV1())

return { __sfc: true,reloaded, tid, useCurrentUserQuery, usePipelinesDashboardQuery, useLastRunsQuery, modelCurrentUserQueryV1, runCurrentUserQueryV1, userId, modelPipelinesDashboardQueryV1, runPipelinesDashboardQueryV1, organiationUnitId, modelLastRunsQueryV1, runLastRunsQueryV1, lastRuns }
}

})